import { createSlice } from "@reduxjs/toolkit";
const currentPurchase = createSlice({
    name: 'currentPurchase',
    initialState: {
        currentPurchase:null
    },
    reducers: {
        setPurchase : (state,action) => { 
            state.currentPurchase = action.payload.currentPurchase
        }
        
    }
});
export const  addPurchase  = currentPurchase.actions.setPurchase;
export default currentPurchase.reducer;